<template>
  <dara-form v-slot="{ validate }" :submit="onRegister">
    <dara-row>
      <dara-col
        class="text-center mb-3">
        <dara-input
          v-model="info.company.name"
          :name="$t('company-name-field')"
          type="text"
          rules="required"
          :placeholder="$t('company-name') + '*'" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-select
          v-bind="$attrs"
          :name="$t('country-field')"
          rules="required"
          :value="info.company.country"
          class="mt-1 mb-0"
          @on-change="onCountryChange">
          <option :value="null" disabled>{{ $t('select-country') }}*</option>
          <option
            v-for="country in countries"
            :key="country.key"
            :value="country.key">
            {{ $t(country.value) }}
          </option>
        </dara-select>
      </dara-col>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-select
          ref="states"
          v-bind="$attrs"
          :name="$t('state-field')"
          rules="required"
          :value="info.company.state"
          class="mt-1 mb-0"
          :disabled="!info.company.country"
          @on-change="onStateChange">
          <option :value="null" disabled>{{ $t('select-state') }}*</option>
          <option
            v-for="state in states"
            :key="state.key"
            :value="state.key">
            {{ state.value }}
          </option>
        </dara-select>
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-select
          ref="cities"
          v-bind="$attrs"
          :name="$t('city-field')"
          rules="required"
          :value="info.company.city"
          class="mt-1 mb-0"
          :disabled="!info.company.state"
          @on-change="onCityChange">
          <option :value="null" disabled>{{ $t('select-city') }}*</option>
          <option
            v-for="city in cities"
            :key="city.name"
            :value="city.name">
            {{ city.name }}
          </option>
        </dara-select>
      </dara-col>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-input
          v-model="info.company.zip"
          :name="$t('zip-code-field')"
          type="text"
          rules="required"
          :placeholder="$t('zip-code') + '*'" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-input
          v-model="info.company.first_address"
          :name="$t('address-field')"
          type="text"
          rules="required"
          :placeholder="$t('street-po-box') + '*'" />
      </dara-col>
      <dara-col
        class="text-center mb-3"
        :sm="12">
        <dara-input
          v-model="info.company.second_address"
          :name="$t('address-complement-field')"
          type="text"
          rules="required"
          :placeholder="$t('building-apartment-floor') + '*'" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3">
        <dara-input
          v-model="info.company.vat"
          :name="$t('vat-field')"
          type="text"
          rules="required"
          :placeholder="$t('vat-identification-number') + '*'" />
      </dara-col>
    </dara-row>
    <dara-row>
      <dara-col
        class="text-center mb-3">
        <dara-button
          class="btn btn-dark me-2"
          @click="previous">
          {{ $t('previous-step') }}
        </dara-button>
        <dara-button
          native-type="submit"
          class="btn btn-primary"
          @click="validate">
          {{ $t('register') }}
        </dara-button>
      </dara-col>
    </dara-row>
  </dara-form>
</template>

<script>

import { COUNTRIES, BRAZIL, CANADA, UNITED_STATES } from '@/assets/resources/state-country';
import { CITIES_OF_BRAZIL } from '@/assets/resources/cities_of_brazil';
import { CITIES_OF_CANADA } from '@/assets/resources/cities_of_canada';
import { CITIES_OF_UNITED_STATES } from '@/assets/resources/cities_of_united_states';

export default {
  name: 'DaraCompanyRegisterInformation',
  inject: ['infoRegisterVm'],
  props: {
    language: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      countries: COUNTRIES,
      states: null,
      cities: null,
      info: this.infoRegisterVm.info,
    };
  },
  created() {
    if (this.info.company.country) {
      if (this.info.company.country === 'brazil') {
        this.states = BRAZIL;
      } else if (this.info.company.country === 'canada') {
        this.states = CANADA;
      } else {
        this.states = UNITED_STATES;
      }
    }
  },
  methods: {
    onRegister() {
      this.$emit('onRegister');
    },
    previous() {
      this.$emit('previous');
    },
    onCountryChange(country) {
      this.info.company.country = country;
      this.info.company.state = null;
      this.info.company.city = null;
      this.$refs.states.localValue = null;
      this.$refs.cities.localValue = null;
      if (country === 'brazil') {
        this.states = BRAZIL;
      } else if (country === 'canada') {
        this.states = CANADA;
      } else {
        this.states = UNITED_STATES;
      }
    },
    onStateChange(state) {
      this.info.company.state = state;
      this.info.company.city = null;
      this.$refs.cities.localValue = null;
      if (this.info.company.country === 'brazil') {
        this.cities = CITIES_OF_BRAZIL[state];
      } else if (this.info.company.country === 'canada') {
        this.cities = CITIES_OF_CANADA[state];
      } else {
        this.cities = CITIES_OF_UNITED_STATES[state];
      }
    },
    onCityChange(city) {
      this.info.company.city = city;
    },
  },
};
</script>
